'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';

class AddGroupStore {
  @observable searchDeviceArr = [];
  @observable selectedDeviceArr = [];
  @observable selectedRowKeys = [];
  @observable selectedDevicePageSize = 10;
  @observable searchDevicePageSize = 10;

  loadAppList() {
    return fetch(`/api/app`, { method: 'GET' }, json => json);
  }
  loadDeviceType() {
    return fetch(`/api/device/type/list`, { method: 'GET' }, json => json);
  }
  getCurrentOta() {
    return fetch(`/api/ota/current`, { method: 'GET' }, json => json);
  }
  @action
  searchDevice(data) {
    let para = buildUrl({
      page_size: 100000,
      page_num: 1,
      device_id: data.device_id,
      model: data.modelNum,
      firmware: data.firmware,
      appId: data.appId,
      appVersion: data.appVersion,
      province: data.province,
      city: data.city
    });
    fetch(`/api/tag/device${para}`, { method: 'GET' }, json => {
      this.searchDeviceArr = json.content.map((item, index) => {
        item.tagDevice.key = index;
        return item.tagDevice;
      });
    });
  }
  @action
  postTag(data) {
    return fetch(
      `/api/tag`,
      {
        method: 'POST',
        body: data
      },
      json => json
    );
  }
  @action.bound
  changeSelectedPageSize(e) {
    this.selectedDevicePageSize = parseInt(Math.abs(e.target.value)) || 1;
  }
  @action.bound
  changeSearchDevicePageSize(e) {
    this.searchDevicePageSize = parseInt(Math.abs(e.target.value)) || 1;
  }
}

export default new AddGroupStore();



// WEBPACK FOOTER //
// ./src/store/DeviceGroup/AddGroup.js